export default __webpack_public_path__ + "static/media/Men.e92faa55.png";